/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_insole = /** @type {(inputs: {}) => string} */ () => {
	return `Stélka`
};

const da_attributes_insole = /** @type {(inputs: {}) => string} */ () => {
	return `Indlægssål`
};

const de_attributes_insole = /** @type {(inputs: {}) => string} */ () => {
	return `Einlegesohle`
};

const en_attributes_insole = /** @type {(inputs: {}) => string} */ () => {
	return `Insole`
};

const es_attributes_insole = /** @type {(inputs: {}) => string} */ () => {
	return `Plantilla`
};

const fr_attributes_insole = /** @type {(inputs: {}) => string} */ () => {
	return `Semelle intérieure`
};

const hu_attributes_insole = /** @type {(inputs: {}) => string} */ () => {
	return `Talpbetét`
};

const it_attributes_insole = /** @type {(inputs: {}) => string} */ () => {
	return `Soletta`
};

const nl_attributes_insole = /** @type {(inputs: {}) => string} */ () => {
	return `Inlegzool`
};

const pl_attributes_insole = /** @type {(inputs: {}) => string} */ () => {
	return `Wkładka`
};

const pt_attributes_insole = /** @type {(inputs: {}) => string} */ () => {
	return `Palmilha`
};

const sv_attributes_insole = /** @type {(inputs: {}) => string} */ () => {
	return `Innersula`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_insole = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_insole(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_insole", locale)
	if (locale === "cs") return cs_attributes_insole(inputs)
	if (locale === "da") return da_attributes_insole(inputs)
	if (locale === "de") return de_attributes_insole(inputs)
	if (locale === "en") return en_attributes_insole(inputs)
	if (locale === "es") return es_attributes_insole(inputs)
	if (locale === "fr") return fr_attributes_insole(inputs)
	if (locale === "hu") return hu_attributes_insole(inputs)
	if (locale === "it") return it_attributes_insole(inputs)
	if (locale === "nl") return nl_attributes_insole(inputs)
	if (locale === "pl") return pl_attributes_insole(inputs)
	if (locale === "pt") return pt_attributes_insole(inputs)
	return sv_attributes_insole(inputs)
};
export { attributes_insole as "attributes.insole" }